/**
 * Leave the public login app via a full document load so Traefik can
 * serve the protected portal bundle (cookie-gated). Client-side router
 * navigation would stay inside public-auth and bounce back to sign-in.
 */
export function enterPortalApp(url?: string | null): void {
  const raw = (url || '/').trim() || '/';
  if (raw.startsWith('/auth')) {
    return;
  }
  const target = raw.startsWith('/') ? raw : `/${raw}`;
  window.location.replace(target);
}
